import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { fmt, errMsg, bizSlug } from "@/lib/api";
import { useBrand, Branded, BrandLogo, brandName, PoweredBy } from "@/components/Brand";

const pub = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });
pub.interceptors.request.use((cfg) => { const b = bizSlug(); if (b) cfg.params = { ...(cfg.params || {}), b }; return cfg; });

export default function Confirm() {
  const brand = useBrand();
  const { token } = useParams();
  const [s, setS] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => { pub.get(`/public/confirm/${token}`).then((r) => setS(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);

  const confirm = async () => {
    setBusy(true);
    try { const r = await pub.post(`/public/confirm/${token}`); setS(r.data); setDone(true); } catch (e) { setErr(errMsg(e)); } finally { setBusy(false); }
  };

  return (
    <Branded brand={brand}>
    <div className="login fade" style={{ maxWidth: 440 }} data-testid="confirm-page">
      <div className="brand" style={{ marginBottom: 16 }}><BrandLogo brand={brand} size={34} testId="confirm-brand-logo" /><div><b style={{ fontSize: 16 }} data-testid="confirm-brand-name">{brandName(brand).toUpperCase()}</b><small>SESSION CONFIRMATION</small></div></div>
      {err && <div className="err" data-testid="confirm-error">{err}</div>}
      {!s && !err && <div className="center" style={{ minHeight: 120 }}><span className="spin" /></div>}
      {s && (
        <>
          <p style={{ color: "var(--ink)", fontSize: 15, marginBottom: 6 }}>Hey {s.firstName},</p>
          <h1 style={{ letterSpacing: 0, fontSize: 22 }} data-testid="confirm-title">{s.title}</h1>
          <div className="big num" style={{ fontSize: 30, margin: "8px 0" }} data-testid="confirm-time">{fmt(s.startAt, { weekday: "long", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</div>
          <div className="ss">60 min with Coach Alex{s.focus ? ` · ${s.focus}` : ""}</div>
          {s.prepNote && <div className="msg" style={{ marginTop: 14 }}><div className="who"><span>Prep</span></div><div className="txt">{s.prepNote}</div></div>}
          <div style={{ marginTop: 20 }}>
            {s.canConfirm ? (
              <button className="btn" style={{ width: "100%", padding: 14, fontSize: 15 }} disabled={busy} onClick={confirm} data-testid="confirm-button">I'm coming — confirm</button>
            ) : (
              <div className="chip ok" style={{ fontSize: 14, padding: "10px 14px", width: "100%", justifyContent: "center" }} data-testid="confirm-status">
                <span className="dot" />{done ? "Confirmed — see you at the bar." : s.status === "CONFIRMED" ? "You're confirmed for this session." : `Status: ${s.status.toLowerCase().replace("_", " ")}`}
              </div>
            )}
          </div>
          <p className="ss" style={{ marginTop: 18, textAlign: "center" }}>Need a different time? <Link to="/login" style={{ fontWeight: 700 }} data-testid="confirm-login-link">Sign in to pick a free slot</Link></p>
        </>
      )}
      <PoweredBy />
    </div>
    </Branded>
  );
}
